import * as yup from 'yup';

import { MIN_PW_LENGTH } from '@olo-web/utils/common/constants';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const usPostalCodeRegex = '^[0-9]{5}(-[0-9]{4})?$';
export const caPostalCodeRegex =
  '^[ABCEGHJ-NPRSTVXY]{1}[0-9]{1}[ABCEGHJ-NPRSTV-Z]{1}[ ]?[0-9]{1}[ABCEGHJ-NPRSTV-Z]{1}[0-9]{1}$';

export const commonValidationSchema = {
  firstName: yup.string().required('Please enter your first name').trim(),
  lastName: yup.string().required('Please enter your last name').trim(),
  email: yup.string().email('Email is not formatted properly').required('Please enter your email'),
  password: yup
    .string()
    .required('Please create a password')
    .min(MIN_PW_LENGTH, `Must be at least ${MIN_PW_LENGTH} characters long`),
  confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match'),
  phone: yup
    .string()
    .required('A phone number is required')
    .test('phone', 'Please enter a valid phone number', (value) => {
      return isValidPhoneNumber(value);
    }),
  cardNumber: yup.number().typeError('Please enter your card number'),
  expirationDate: yup.number().required('Please enter the Expiration date'),
  zipCode: yup
    .string()
    .required('Please enter your Billing ZIP code')
    .min(5, 'Please enter a valid ZIP/postal code in the United States or Canada'),
  cvv: yup.number().max(3, "CVV can't contain more then 3 digit").required('Please enter CVV/CVC'),
};

export const contactInformationValidationSchema = yup.object().shape({
  firstName: commonValidationSchema.firstName,
  lastName: commonValidationSchema.lastName,
  email: commonValidationSchema.email,
  phoneNo: commonValidationSchema.phone,
});
